import { useMemo } from 'react'
import { Polygon } from 'react-leaflet'
import { useReferencePolygons } from './use-reference-polygons'

export const ReferencePolygonLayer = ({ farmId }) => {
  const { polygons } = useReferencePolygons(farmId)

  const polygonData = useMemo(() => {
    if (!polygons || polygons.length === 0) return []

    return polygons
      .filter(p => p.points && Array.isArray(p.points) && p.points.length >= 3)
      .map(p => ({
        ...p,
        positions: p.points
          .filter(pt => pt && typeof pt.x === 'number' && typeof pt.y === 'number')
          .map(pt => [pt.y, pt.x])
      }))
      .filter(p => p.positions.length >= 3)
  }, [polygons])

  if (!polygonData.length) return null

  return (
    <>
      {polygonData.map(polygon => (
        <Polygon
          key={polygon.id}
          positions={polygon.positions}
          pathOptions={{
            color: polygon.colour,
            fillColor: polygon.colour,
            fillOpacity: 0.25,
            weight: 2,
          }}
        />
      ))}
    </>
  )
}
